import { useEffect, useState } from "react";
import ButtonCustom from "./ButtonCustom";
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from "@material-ui/core";
import { ArrowDownIcon, CheckIcon, DeleteIcon, DeleteWhiteIcon, MasterIcon, PaypalIcon, StripeIcon, VisaIcon } from "./icons";
import CustomizedCircularProgress from "./CircularProgress";
import crmservices from "../wsclient";
import client from 'braintree-web/client'
import checkout from 'braintree-web/paypal-checkout'
import braintree from 'braintree-web'
import { getContacts } from "../utils/common";
import CustomTypo from "./CustomTypo";
import { connection, domainName } from "../../portal.config";

// accountt 
// sb-zohys7237983@business.example.com
// M;SB31?x
// EJ37VS8BQHJVA
// sb-2vtnz7239030@personal.example.com
// 0pB{^r7P
// RB7JN2DTVU566
// sb-xtymq7240364@personal.example.com
// 2Oasr!Sz
// 5Z3ABHFRWGEMY

function Stripe(props) {
    const [clientToken, setClientToken] = useState(null);
    const [showLoading, onShowLoading] = useState(false);
    const [stripes, setStripes] = useState(props.stripes);
    const { classes, t } = props;

    useEffect(() => {
        setStripes(props.stripes)
    }, [props.stripes])

    const onRemoveCard = async (item) => {
        onShowLoading(true)
        try {
            let removePaymentMethod = await crmservices.paymentgateway.removePaymentMethod({ payment_method_id: item.id });
            if (removePaymentMethod.code == 'OK') {
                let paymentMethod = await props.onRefresh();
                setStripes(paymentMethod)
            }
        }
        catch (e) {
            onShowLoading(false)
        }
        onShowLoading(false)
    }

    console.log('stripes===', stripes);

    return (
        <Grid item container justify='center' className={classes.container}>
            <Grid item xs={12}>
                {showLoading && <CustomizedCircularProgress />}
            </Grid>
            {stripes.length > 0 && stripes.map((item, index) => <CardItem key={index} item={item} classes={classes} setPrimaryCard={props.setPrimaryCard} onRemoveCard={onRemoveCard} />)}
        </Grid>
    )
}
function CardItem(props) {
    const { classes, item } = props
    //console.log('CardItem=== ',item)
    let card_holder_name = item.card && item.card.card_holder_details && item.card.card_holder_details.card_holder_name ? item.card.card_holder_details.card_holder_name : ""
    return (
        <Grid xs={12} item container className={classes.method_container}>
            <Grid xs={11} item className={classes.method_pre}>
                <Grid item className={classes.method} container alignItems='center' onClick={() => props.setPrimaryCard(item.id)}>
                    <Grid xs={2} item container justify='flex-start'>
                        {/* {item.brand === 'master' ? <MasterIcon /> : <VisaIcon />} */}
                        <StripeIcon style={{width:80,height:40,objectFit:'contain'}}/>
                    </Grid>
                    <Grid xs={8} item>
                        <CustomTypo mg_left_sm variant='body1'>{item && item.card && item.card.last4 ? "**** **** **** " + item.card.last4 : ""}</CustomTypo>
                    </Grid>
                    {item.is_primary && <Grid xs={2} item container justify='flex-end' >
                        <CheckIcon />
                    </Grid>}
                </Grid>
            </Grid>
            <Grid xs={1} item container justify='flex-end' alignItems='center'>
                <div className={classes.bg_icon} onClick={() => props.onRemoveCard(item)}>
                    <DeleteWhiteIcon />
                </div>
            </Grid>
        </Grid>
    )
}
const styles = theme => ({
    container: {
        marginTop: theme.spacing(8)
    },
    method_container: {
        padding: theme.spacing(4, 0, 0, 0)
    },
    method_pre: {
        padding: theme.spacing(0, 2, 0, 0)
    },
    method: {
        backgroundColor: theme.palette.background.light,
        borderRadius: theme.spacing(2),
        // height: theme.spacing(12),
        padding: theme.spacing(1, 4, 1, 4),
        cursor: 'pointer',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1, 2, 1, 2),
        }
    },
    button_add: {
        marginTop: theme.spacing(10)
    },
    bg_icon: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    }
});
export default withStyles(styles)(withTranslation()(Stripe));